<div class="notifications">
  @for (notification of notifications(); track notification.id) {
    <cq-notification [notification]="notification" @fade></cq-notification>
  }
</div>
